export default {
    props: {
        categories: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        getFilterFromCategories(categories) {
            const categoryFilter = categories.reduce((objectsByKeyValue, obj) => {
                let parent = this.getTopLevelParent(this.getCategoryById(obj.parent))

                if (!objectsByKeyValue[parent.slug]) {
                    objectsByKeyValue[parent.slug] = []
                }
                objectsByKeyValue[parent.slug].push(obj.slug)
                return objectsByKeyValue
            }, {})

            const sortedFilter = {}
            Object.keys(categoryFilter).sort().forEach(key => {
                sortedFilter[key] = categoryFilter[key].sort().join(',')
            })

            return sortedFilter
        },
        getCategoryById(id) {
            return this.categories.find(c => c.id === id)
        },

        getTopLevelParent(category) {
            while (category.parent !== 0) {
                category = this.getCategoryById(category.parent)
            }
            return category
        },
    }
}
